import { useState } from "react";
import Modal from "../../elements/Modal";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import commoncss from "../../../myfin_v2/css/common.module.css"
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as NoMatchEntryIcon } from "../../../myfin_v2/assets/icons/noMatchEntry.svg";

const ColorInfoModal = ({ handleClose }) => {

    return(
        <>
            <Modal
                width="700px"
                title="Color Meaning"
                bodycss={commoncss.unsetPadding}
                headerActions={
                    <CloseIcon
                        className="clickable"
                        onClick={handleClose}
                    />
                }
            >

                <div className={commoncss.pd1530}>
                    <div style={{ display:"flex",flexDirection:"column", gap:"20px" }}>
                        <div style={{ display:"flex",flexDirection:"column", gap:"10px" }}>
                            <div style={{ display:"flex",alignItems:"center", gap:"10px" }}>
                                <div style={{ height:"40px", width:"40px", border:"1px solid #A0DABC", background:"#E9F5EB", borderRadius:"10px" }}></div>
                                <div>Fully Matched Entries</div>
                            </div>
                            <div style={{ color:"#183930", fontSize:"14px" }}>
                                Lorem ipsum dolor sit amet consectetur. Euismod arcu dictum non pulvinar suspendisse nulla.
                            </div>
                        </div>
                        <div style={{ display:"flex",flexDirection:"column", gap:"10px" }}>
                            <div style={{ display:"flex",alignItems:"center", gap:"10px" }}>
                                <div style={{ height:"40px", width:"40px", border:"1px solid #E6CE7E", background:"#FFF6E3", borderRadius:"10px" }}></div>
                                <div>Partially Matched Entries</div>
                            </div>
                            <div style={{ color:"#183930", fontSize:"14px" }}>
                                Lorem ipsum dolor sit amet consectetur. Euismod arcu dictum non pulvinar suspendisse nulla.
                            </div>
                        </div>
                        <div style={{ display:"flex",flexDirection:"column", gap:"10px" }}>
                            <div style={{ display:"flex",alignItems:"center", gap:"10px" }}>
                                <div>
                                    <NoMatchEntryIcon height={40} width={40}/>
                                </div>
                                <div>Partially Matched Entries</div>
                            </div>
                            <div style={{ color:"#183930", fontSize:"14px" }}>
                                Lorem ipsum dolor sit amet consectetur. Euismod arcu dictum non pulvinar suspendisse nulla.
                            </div>
                        </div>
                    </div>
                </div>
                
            </Modal>
        </>
    )

}

export default ColorInfoModal;